
<div>
  <div
    v-for="field in section.nonElementFields"
    :key="`${field.id}-${dropdownControlId}`"
  >
    <field-item
      :disabled="handler.isDisabled(field, parentTreeContext)"
      @click="select(field.select(field, section.workflowStep))"
    >
      <row>
        <prefix>
          <icon :glyph="modelTypeIcon(field.modelType)"/>
        </prefix>

        <column>
          {{ field.label }}
        </column>
      </row>
    </field-item>
  </div>

  <template v-if="!handler.hideWorkflowStepData">
    <strong class="crayon red">Default Workflow Data</strong>

    <div v-for="element in section.dateOptions" :key="element.id">
      <button
        @click="select(element.select(element))"
        type="button"
        class="field-item"
        :class="{'disabled-link': handler.isDisabled(element, parentTreeContext)}"
        :disabled="handler.isDisabled(element, parentTreeContext)"
      >
        <row>
          <prefix>
            <icon glyph="datepicker" />
          </prefix>

          <column>
            {{element.label}}
          </column>
        </row>
      </button>
    </div>
  </template>
</div>
